module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idea-card container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "reviews"
  }, [_c('div', {
    staticClass: "container idea-page"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2 back-remove"
  }, [_c('button', {
    staticClass: "button-back",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ideas'
        })
      }
    }
  }, [_c('span', [_vm._v("Назад")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-10 mobile-rew"
  }, [(_vm.idea) ? _c('Idea', {
    attrs: {
      "idea": _vm.idea
    },
    on: {
      "deleted": function($event) {
        _vm.$router.push({
          name: 'ideas'
        })
      }
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.idea.status_id > 1 || _vm.isAdmin || _vm.idea.user_id === _vm.user.id) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "reviews-messages col-md-10 col-md-offset-2"
  }, [(_vm.idea.comments > 0) ? _c('h3', [_vm._v("Комментарии:     " + _vm._s(_vm.idea.comments))]) : _vm._e(), _vm._v(" "), (_vm.idea.comments == 0) ? _c('h3', [_vm._v("Пока что нет комментариев.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.idea.rootComments), function(comment) {
    return _c('Comment', {
      key: comment.id,
      attrs: {
        "comment": comment
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "reviews-form-block"
  }, [_c('div', {
    staticClass: "reviews-form col-md-10 col-md-offset-2"
  }, [(!_vm.isLogged) ? _c('div', [_c('em', [_vm._v("Необходимо "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("авторизоваться")]), _vm._v(", чтобы оставить комментарий.")], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('div', [_c('Editor', {
    attrs: {
      "placeholder": "Оставьте комментарий",
      "content": _vm.newCommentHtml
    },
    on: {
      "change": _vm.setNewComment,
      "ctrl-enter": function($event) {
        !_vm.hasErrorComment(_vm.newCommentText) && _vm.saveComment()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1em",
      "margin": "1em 0"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSmallComment(_vm.newCommentText)),
      expression: "hasSmallComment(newCommentText)"
    }]
  }, [_c('em', [_vm._v("Сообщение должно быть как минимум 20 символов.")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasNormalComment(_vm.newCommentText)),
      expression: "hasNormalComment(newCommentText)"
    }]
  }, [_c('em', [_vm._v("Длина сообщения " + _vm._s(_vm.newCommentText.length) + " из 4096 символов.")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasLargeComment(_vm.newCommentText)),
      expression: "hasLargeComment(newCommentText)"
    }],
    staticClass: "error"
  }, [_c('em', [_vm._v("Слишком длинное сообщение. " + _vm._s(_vm.newCommentText.length) + " из 4096 символов.")])])]), _vm._v(" "), _c('button', {
    staticClass: "reviews-button",
    attrs: {
      "disabled": _vm.hasErrorComment(_vm.newCommentText)
    },
    on: {
      "click": _vm.saveComment
    }
  }, [_vm._v("Отправить")])], 1) : _vm._e()])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e1810f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IdeaPage.vue
// module id = 111
// module chunks = 0